import { debounce } from '~/helpers/debounce'

// @ts-nocheck
export default defineNuxtPlugin(() => {
  const { $pwa } = useNuxtApp()
  const router = useRouter()
  const cartStore = useCartStore()
  const wishlistStore = useWishlistStore()
  const { massFetch } = useNotifications()

  window.addEventListener('focus', () => {
    wishlistStore.sync()
    cartStore.softSync()
    massFetch()
  })

  router.beforeEach(() => {
    // if ($pwa?.needRefresh) {
    $pwa?.updateServiceWorker(true)
    // }
  })

  router.afterEach(to => {
    massFetch()
    if (to.name?.includes('-checkout')) { return } // checkout page updates and then syncs cart on its own
    wishlistStore.sync()
    cartStore.sync()
  })
})
